import { render, staticRenderFns } from "./PersonnelOverview_ListActivities.vue?vue&type=template&id=edbd3c0a&scoped=true&"
import script from "./PersonnelOverview_ListActivities.vue?vue&type=script&lang=js&"
export * from "./PersonnelOverview_ListActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd3c0a",
  null
  
)

export default component.exports